import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createSamplePriceEntry = createAsyncThunk('createSamplePriceEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertSamplePrice`, postData);
        console.log(response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const updateRackEntry = createAsyncThunk('updateRackEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateRack`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSamplePriceData = createAsyncThunk('fetchSamplePriceData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSamplePricelist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleRack = createAsyncThunk('fetchSingleRack', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getRacklist&rackId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleSample = createAsyncThunk('deleteSingleSample', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteSamplePrice&sampleId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


// brand entry

export const insertBrandEntry = createAsyncThunk('insertBrandEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertbrandentry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateBrandEntry = createAsyncThunk('updateBrandEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateBrand`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchBrandData = createAsyncThunk('fetchBrandData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getBrandlist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleBrand = createAsyncThunk('fetchSingleBrand', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getBrandlist&brandId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteSingleBrand = createAsyncThunk('deleteSingleBrand', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteBrand&brandId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const rackSlice = createSlice({
    name: 'SamplePriceData',
    initialState: {
        isLoading: false,
        sampleprice: null,
        deleteRack: null,
        singleRack: null,
        brand: null,
        singlebrand: null,
        delbrand: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSamplePriceData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSamplePriceData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.sampleprice = action.payload;
        });
        builder.addCase(fetchSamplePriceData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleSample.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleSample.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteRack = action.payload;
        });
        builder.addCase(deleteSingleSample.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleRack.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleRack.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleRack = action.payload;
        });
        builder.addCase(fetchSingleRack.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchBrandData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchBrandData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.brand = action.payload;
        });
        builder.addCase(fetchBrandData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleBrand.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleBrand.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singlebrand = action.payload;
        });
        builder.addCase(fetchSingleBrand.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleBrand.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleBrand.fulfilled, (state, action) => {
            state.isLoading = false;
            state.delbrand = action.payload;
        });
        builder.addCase(deleteSingleBrand.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default rackSlice.reducer;
